import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import { Activity } from 'lucide-react';

export default function MemUsageChartSkeleton() {
    return (
        <div className="oct_sys-chart-card-v2">
            <div className="oct_sys-chart-header-v2 mb-4">
                <Activity className="oct_icon" />
                <h3>Memory Usage</h3>
            </div>

            <div className="oct_sys-mem-stats-list-v2">
                {[...Array(5)].map((_, i) => (
                    <div className="stat-row" key={i}>
                        <Skeleton variant="text" width="30%" />
                        <Skeleton variant="text" width="40%" />
                    </div>
                ))}
            </div>

            <div className="oct_sys-mem-progress-wrapper-v2">
                <div className="progress-header">
                    <Skeleton variant="text" width="20%" />
                    <Skeleton variant="text" width="15%" />
                </div>
                <div className="progress-bg mt-1 oct_skeleton-padding-top-025">
                    <Skeleton variant="rectangular" width="100%" height={12} sx={{ borderRadius: 9999 }} />
                </div>
            </div>
        </div>
    );
}
